import types from "./types";
import initialState from "./initialState";

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_STATIC_DATA:
      return {
        ...state,
        loading: true
      };

    case types.GET_STATIC_DATA_SUCCESS:
      const {
        issueTypes,
        projectStatuses,
        urgencyLevel,
        fiscalYears,
        budgetRanges,
        municipalities,
        projectBudgetProgramTypes,
        projectBudgetProgramSubTypes
      } = action.payload;

      return {
        ...state,
        issueTypes,
        projectStatuses,
        urgencyLevel,
        fiscalYears,
        budgetRanges,
        municipalities,
        loading: false,
        projectBudgetProgramTypes,
        projectBudgetProgramSubTypes
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/infraMonitor/staticData/reducers.js